import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CommonInput from "../../../components/input/CommonInput";
import {
  emailValidator,
  getErrorMessage,
  handleBlanckSpaceInput,
  passwordValidator,
} from "../../../constants/globalFunction";
import { imagePath } from "../../../constants/imagePath";
  import BrandLogo from "../../../components/BrandLogo";
import CommonButton from "../../../components/button/CommonButton";
import { showErrorToast } from "../../../utils/toast";
import { FaEnvelope, FaLock } from "react-icons/fa";
import "./Login.css";
import { appApiHandler } from "../../../api/appApiHandler";
import { setUserData } from "../../../store/slices/userState";
import {
  saveToken,
  saveUserId,
  saveUserType,
} from "../../../constants/asyncStoreManager";
import { setIsLoggedIn } from "../../../store/slices/authState";
import { string } from "../../../constants/string";




const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  const validate = () => {
    let ok = true;
    if (!email.trim()) {
      setEmailError("Please enter email");
      ok = false;
    } else if (!emailValidator(email)) {
      setEmailError("Please enter a valid email");
      ok = false;
    } else {
      setEmailError("");
    }

    if (!password.trim()) {
      setPasswordError("Please enter password");
      ok = false;
    } else if (!passwordValidator(password)) {
      setPasswordError(
        "Password must be at least 8 characters and include one uppercase letter, one number, and one special character"
      );
      ok = false;
    } else {
      setPasswordError("");
    }
    return ok;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const reqData = {
        email: email.trim(),
        password: password.trim(),
        token: "Test",
      };
      setSubmitting(true);
      const response = await appApiHandler.login(reqData);

      if (response?.status === 200) {
        await saveUserId(response?.data?._id);
        await saveUserType(response?.data?.user_type);
        await saveToken(response?.token);
        dispatch(setUserData(response?.data));
        dispatch(setIsLoggedIn(true))

        navigate("/");
      } else if (response?.message) {
        console.log("response?.message",response?.message)
        showErrorToast(getErrorMessage(response?.message));
      } else {
        showErrorToast(string.error.failed_due_to_internal_error);
      }
    } catch (err) {
      console.log("Login Error",err)
      showErrorToast(string.error.failed_due_to_internal_error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
  <>
     
   
    <div className="login-page" style={{ backgroundImage: `url(${imagePath.background})` }}>
      <div className="login-card">
        <BrandLogo alt="Yug Mantra" className="login-logo" isStaticPage={true} />
        <h1 className="login-title">Welcome Back</h1>
        <form onSubmit={onSubmit}>
          <CommonInput
            label="Email"
            value={email}
            onChange={setEmail}
            placeholder="Enter email"
            error={emailError}
            type="email"
            leftIcon={<FaEnvelope className="login-icon" />}
          />
          <CommonInput
            label="Password"
            value={password}
            onChange={(value) => setPassword(handleBlanckSpaceInput(value))}
            placeholder="Enter password"
            error={passwordError}
            secureTextEntry
            leftIcon={<FaLock className="login-icon" />}
          />
          <div
            className="login-forgot"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </div>
          <CommonButton
            title={isSubmitting ? "Logging in…" : "Log In"}
            type="submit"
            disabled={isSubmitting}
          />
        </form>
        {/* <div className="login-divider-wrap">
          <div className="login-line" />
          <div className="login-or">Or</div>
          <div className="login-line" />
        </div>
        <CommonButton title="Login with Google" outlined onPress={() => {}} />*/}
        <div className="login-bottom-text">
          Don't have an account?{" "}
          <span className="login-signup" onClick={() => navigate("/signup")}>
            Sign Up
          </span>
        </div>
      </div>
    </div>
    </>
  );
};

export default Login;
